// extracted by mini-css-extract-plugin
export default {"form":"AddMultiple_form__KLhdQ"};